







































import Vue, { PropType } from "vue";
import { AanvraagGAStatus } from "../../types/NBE/AanvraagGAStatus";
import { AanvraagGeldigeAncienniteit } from "../../types/NBE/AanvraagGeldigeAncienniteit";
import { Tewerkstellingsgegevens } from "../../types/NBE/Tewerkstellingsgegevens";
import ListItem from "../interface/ListItem.vue";
import TewerkstellingsOverzicht from "./TewerkstellingsOverzicht.vue";

export default Vue.extend({
  components: { ListItem, TewerkstellingsOverzicht },
  name: "aanvraag-ga-overzicht",
  props: {
    aanvraagGa: {
      type: Object as PropType<AanvraagGeldigeAncienniteit>,
    },
  },
  methods: {
    booleanToString(bool: boolean) {
      if (bool) {
        return "Ja";
      }
      return "Nee";
    },
    statusToString(aanvraagGAStatus: AanvraagGAStatus): string {
      if (aanvraagGAStatus == AanvraagGAStatus.InProgress) {
        return "In behandeling";
      } else if (aanvraagGAStatus == AanvraagGAStatus.Processed) {
        return "Behandeld";
      } else if (aanvraagGAStatus == AanvraagGAStatus.NeedsInfo) {
        return "Vereist info";
      }
      return "Ongekend";
    },
    statusColorClass(aanvraagGAStatus: AanvraagGAStatus): string {
      if (aanvraagGAStatus == AanvraagGAStatus.InProgress) {
        return "text-primary";
      } else if (aanvraagGAStatus == AanvraagGAStatus.Processed) {
        return "Behandeld";
      } else if (aanvraagGAStatus == AanvraagGAStatus.NeedsInfo) {
        return "text-warning";
      }
      return "Ongekend";
    },
  },

  computed: {
    tewGegBinnenOnderwijs(): Tewerkstellingsgegevens[] {
      return this.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs;
    },
    tewGegBuitenOnderwijs(): Tewerkstellingsgegevens[] {
      return this.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs;
    },
    tewGegOpenbaarAmbt(): Tewerkstellingsgegevens[] {
      return this.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt;
    },
    tewGegOnbezoldigd(): Tewerkstellingsgegevens[] {
      return this.aanvraagGa.onbezoldigdeOnderbrekingen;
    },
    aanvraagHasToestmmingDepHO(): boolean {
      return this.aanvraagGa.toestemmingAanvraagLoopbaanFiche;
    },
  },
});
